<p *ngIf="show_legend" class="p-3" style="font-size: 1.4em; text-align: justify; padding-bottom: 0 !important; font-family: 'Roboto-Bold';">En esta tabla {{main?.txt_tabla}} la cantidad de votos asentada en las Actas PREP de Casilla Especial de Representación Proporcional.</p>
<p *ngIf="!hide_legend" class="p-3" [ngClass]="{'mt-3': !show_legend}" style="font-size: 1.4em; text-align: justify; padding-top: 0 !important; font-family: 'Roboto-Bold';">Por presentación, los decimales de los porcentajes muestran sólo cuatro dígitos. No obstante, al considerar todos los decimales, suman 100%.</p>
<div class="container-fluid resumen-votacion d-none d-xl-block" [ngClass]="{'p-4': hide_legend}">
  <div class="row">
    <div [ngClass]="{'col-8 col-md-8 col-lg-8 col-xl-8': use_observaciones || short, 'col-12 col-md-12 col-lg-12 col-xl-12': !use_observaciones && !short}" class="bgResumen py-2 pxx">
      <p class="titulo">
        <strong>Resumen de la votación</strong>
      </p>
      <div class="container-fluid">
        <div class="row dis-flex">
          <div class="apartado dis-flex flex-row" [ngClass]="{'outer-box': extranjero && !omitir_extranjero && !omitir_borde, 'gubFlex': gubernatura}" *ngIf="!hide_acumulados">
            <span *ngIf="extranjero && !omitir_extranjero && !omitir_borde" class="tooltip-outer"
              tooltip="Es la sumatoria de los votos obtenidos por Partido Político y combinaciones de coalición."
              placement="top" show-delay="200">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
            </span>

            <div *ngIf="extranjero || !extranjero_short" class="dis-flex flex-col" [ngClass]="{'w-50': extranjero && !omitir_extranjero, 'w-100': !extranjero || omitir_extranjero}">
              <div class="dis-flex w-100">
                <p class="subtitulo" *ngIf="!extranjero || omitir_extranjero">
                  Votos acumulados &nbsp;
                </p>
                <p class="subtitulo" *ngIf="extranjero && !omitir_extranjero">
                  En Casillas &nbsp;
                </p>
                <span *ngIf="!extranjero || omitir_extranjero"
                  tooltip="Es la sumatoria de los votos obtenidos por Partido Político y combinaciones de coalición."
                  placement="top" show-delay="200">
                  <i class="fas fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="row dis-flex w-100 space-b">
                <p class="col-12 cantidad">
                  <strong>
                    {{
                      acumulados_num
                    }}
                  </strong>
                </p>
                <p *ngIf="!hide_prc" class="col-12 porcentaje">
                  {{
                    acumulados_prc
                  }}
                </p>
              </div>
            </div>

            <div *ngIf="extranjero_short" class="dis-flex flex-col w-100" >
              <div class="dis-flex w-100">
                <p class="subtitulo">
                  Votos acumulados &nbsp;
                </p>
                <span
                  tooltip="Es la sumatoria de los votos obtenidos por Partido Político y combinaciones de coalición."
                  placement="top" show-delay="200">
                  <i class="fas fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="row dis-flex w-100 space-b">
                <p class="col-12 cantidad">
                  <strong>
                    {{
                      acumulados_num
                    }}
                  </strong>
                </p>
                <p *ngIf="!hide_prc" class="col-12 porcentaje">
                  {{
                    acumulados_prc
                  }}
                </p>
              </div>
            </div>
            
            <p *ngIf="extranjero && !omitir_extranjero" _ngcontent-heg-c78="" class="separador"><strong _ngcontent-heg-c78="">+</strong></p>

            <div *ngIf="extranjero && !omitir_extranjero" class="dis-flex w-50 flex-col">
              <div class="dis-flex w-100">
                <p class="subtitulo">
                  En el Extranjero &nbsp;
                </p>
                <span
                  tooltip="Es la sumatoria de los votos obtenidos por Partido Político y combinaciones de coalición."
                  placement="top" show-delay="200">
                  <i *ngIf="!extranjero || omitir_extranjero" class="fas fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="row dis-flex w-100 space-b">
                <p class="col-12 cantidad">
                  <strong>
                    {{
                      extranjero_num
                    }}
                  </strong>
                </p>
                <p *ngIf="!hide_prc" class="col-12 porcentaje">
                  {{
                    extranjero_prc
                  }}
                </p>
              </div>
            </div>

            <p *ngIf="gubernatura" _ngcontent-heg-c78="" class="separador"><strong _ngcontent-heg-c78="">+</strong></p>

            <div *ngIf="gubernatura" class="dis-flex w-50 flex-col">
              <div class="dis-flex w-100">
                <p class="subtitulo">
                  <!--Votos acumulados-->Anticipados &nbsp;
                </p>
              </div>
              <div class="row dis-flex w-100 space-b">
                <p class="col-12 cantidad">
                  <strong>
                    {{
                      anticipados_num
                    }}
                  </strong>
                </p>
                <p *ngIf="!hide_prc" class="col-12 porcentaje">
                  {{
                    anticipados_prc
                  }}
                </p>
              </div>
            </div>

            <p *ngIf="gubernatura" _ngcontent-heg-c78="" class="separador"><strong _ngcontent-heg-c78="">+</strong></p>

            <div *ngIf="gubernatura" class="dis-flex w-50 flex-col">
              <div class="dis-flex w-100">
                <p class="subtitulo">
                  <!--Votos acumulados-->En Prisión Preventiva &nbsp;
                </p>
              </div>
              <div class="row dis-flex w-100 space-b">
                <p class="col-12 cantidad">
                  <strong>
                    {{
                      prision_num
                    }}
                  </strong>
                </p>
                <p *ngIf="!hide_prc" class="col-12 porcentaje">
                  {{
                    prision_prc
                  }}
                </p>
              </div>
            </div>
          </div>
          <p class="separador" *ngIf="!hide_acumulados">
            <strong>+</strong>
          </p>
          <div *ngIf="force_box" class="apartado dis-flex flex-row custom" [ngClass]="{'outer-box': force_box}">
            <span *ngIf="extranjero && !omitir_extranjero" class="tooltip-outer"
              tooltip="El total y el porcentaje de votos para Candidaturas no registradas y Nulos, considera la votación en Casillas, el Extranjero, Anticipados y en Prisión Preventiva."
              placement="top" show-delay="200">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
            </span>
            <div class="dis-flex flex-col pt-1">
              <div class="dis-flex w-100">
                <p class="subtitulo pb-1">
                  Candidaturas no registradas
                </p>
              </div>
              <div class="row dis-flex w-100 space-b">
                <p class="col-12 cantidad">
                  <strong>
                    {{
                    noregistradas_num
                    }}
                  </strong>
                </p>
                <p *ngIf="!hide_prc" class="col-12 porcentaje">
                  {{
                  noregistradas_prc
                  }}
                </p>
              </div>
            </div>
            <p class="separador">
              <strong>+</strong>
            </p>
            <div class="dis-flex flex-col pt-1">
              <div class="dis-flex w-100">
                <p class="subtitulo pb-1">
                  Nulos
                </p>
              </div>
              <div class="row dis-flex w-100 space-b">
                <p class="col-12 cantidad">
                  <strong>
                    {{
                    nulos_num
                    }}
                  </strong>
                </p>
                <p *ngIf="!hide_prc" class="col-12 porcentaje">
                  {{
                    nulos_prc
                  }}
                </p>
              </div>
            </div>
          </div>
          <div *ngIf="!force_box" class="apartado dis-flex flex-col pt-1">
            <div class="dis-flex w-100">
              <p class="subtitulo pb-1">
                Candidaturas no registradas
              </p>
            </div>
            <div class="row dis-flex w-100 space-b">
              <p class="col-12 cantidad">
                <strong>
                  {{
                  noregistradas_num
                  }}
                </strong>
              </p>
              <p *ngIf="!hide_prc" class="col-12 porcentaje">
                {{
                noregistradas_prc
                }}
              </p>
            </div>
          </div>
          <p class="separador" *ngIf="!force_box">
            <strong>+</strong>
          </p>
          <div class="apartado dis-flex flex-col pt-1" *ngIf="!force_box">
            <div class="dis-flex w-100">
              <p class="subtitulo pb-1">
                Nulos
              </p>
            </div>
            <div class="row dis-flex w-100 space-b">
              <p class="col-12 cantidad">
                <strong>
                  {{
                  nulos_num
                  }}
                </strong>
              </p>
              <p *ngIf="!hide_prc" class="col-12 porcentaje">
                {{
                  nulos_prc
                }}
              </p>
            </div>
          </div>
          <p class="d-none d-lg-block separador pr-3">
            <strong>=</strong>
          </p>
          <div class="d-none d-lg-block apartado dis-flex flex-col">
            <div class="dis-flex w-100 justify-e">
              <p class="px20">
                <strong>Total de votos</strong>
                <span class="tooltip-outer"
                  tooltip="Se refiere a la suma total de votos que realiza el sistema informático con base en los datos que muestran en cada Acta; podrás consultar la cifra del total de votos mostrado en cada Acta en la base de datos del PREP (numeral 26, fr. XIV del Anexo 13 del Reglamento de Elecciones)."
                  placement="top" show-delay="200">
                  <i class="fas fa-info-circle" style="font-size: 1em;margin-left: 5px;" aria-hidden="true"></i>
                </span>
              </p>
            </div>
            <div class="dis-flex w-100 space-b justify-e">
              <p class="total">
                <strong class="txRosaIne">
                  {{ total_num }}
                </strong>
              </p> 
            </div>
            <div *ngIf="!hide_prc" class="dis-flex w-100 justify-e">
              <p>
                <strong>
                  <span class="txRosaIne">{{ total_prc }}</span>
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div class="container-fluid d-lg-none">
          <div class="row">
            <div class="col-12 dis-flex flex-col mt-3">
              <div class="dis-flex w-100 justify-e">
                <p class="px20 mb-0">
                  <strong>Total de votos</strong>
                </p>
              </div>
              <div class="dis-flex w-100 justify-e">
                <p class="total">
                  <strong>
                    = <span class="txRosaIne">
                      {{ total_num }}
                    </span>
                  </strong>
                </p>
              </div>
              <div *ngIf="!hide_prc" class="dis-flex w-100 justify-e">
                <p>
                  <strong>
                    <span class="txRosaIne">
                      {{ total_prc }}
                    </span>
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4 col-md-4 col-lg-4 col-xl-4" *ngIf="use_observaciones">
		<div class="bgResumen resumen-votacion observaciones p-2" >
			<p class="titulo">
				<strong>Observaciones en Acta</strong>
			</p>
			<p>
			{{ observaciones ? observaciones : '' }}
			</p>
		</div>
	</div>
  </div>
</div>

<div class="container-fluid resumen-votacion-mobile d-block d-xl-none">
	<div class="row">
		<div class="col-12">
			<h2 class="title-resumen">Resumen de la votación </h2>

			<div class="list-block" *ngIf="!hide_acumulados" style="border-top: 1px solid var(--border-gw);">
				<p class="tipo-resumen">
					En Casillas &nbsp;
          <span style="position: absolute;right: 10px;top: 5px;"
            tooltip="Es la sumatoria de los votos obtenidos por Partido Político y Coalición."
            placement="top" show-delay="200">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </span>
				</p>
				<div class="dis-flex flex-row justify-content-between">
					<p>{{ acumulados_num }}</p>
					<p *ngIf="!hide_prc" class="block-prc">{{ acumulados_prc }}</p>
				</div>
			</div>

			<div class="list-block" *ngIf="extranjero && !omitir_extranjero">
        <span class="total-plus" *ngIf="!hide_acumulados">+</span>
				<p class="tipo-resumen">
					{{ use_acumulados ? 'Votos Acumulados' : extranjero_num }} &nbsp;
          <span *ngIf="use_acumulados"
            tooltip="Es la sumatoria de los votos obtenidos por Partido Político y Coalición."
            placement="top" show-delay="200">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </span>
				</p>
				<div class="dis-flex flex-row justify-content-between">
					<p>{{ use_acumulados ? acumulados_num : extranjero_num }}</p>
					<p *ngIf="!hide_prc || force_prc" class="block-prc">{{ use_acumulados ? acumulados_prc : extranjero_prc }}</p>
				</div>
			</div>

			<div class="list-block" *ngIf="use_anticipados_preventivos">
        <span class="total-plus">+</span>
				<p class="tipo-resumen">
					Anticipados &nbsp;
				</p>
				<div class="dis-flex flex-row justify-content-between">
					<p>{{ anticipados_num }}</p>
					<p *ngIf="!hide_prc" class="block-prc">{{ anticipados_prc }}</p>
				</div>
			</div>

			<div class="list-block" *ngIf="use_anticipados_preventivos">
        <span class="total-plus">+</span>
				<p class="tipo-resumen">
					En Prisión Preventiva &nbsp;
				</p>
				<div class="dis-flex flex-row justify-content-between">
					<p>{{ prision_num }}</p>
					<p *ngIf="!hide_prc" class="block-prc">{{ prision_prc }}</p>
				</div>
			</div>
		</div>
	</div>

  <div class="row" *ngIf="use_anticipados_preventivos">
    <div class="col-12">
      <span class="row-plus">+</span>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="list-block">
        <span class="total-plus" *ngIf="!use_anticipados_preventivos">+</span>
				<p class="tipo-resumen">
					Candidaturas no registradas &nbsp;
          <span style="position: absolute;right: 10px;top: 5px;"
            tooltip="El total y porcentaje de votos para Candidaturas no registradas y Nulos, considera la votación en Casillas, el Extranjero, Anticipada y de Personas en Prisión Preventiva."
            placement="top" show-delay="200">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </span>
				</p>
				<div class="dis-flex flex-row justify-content-between">
					<p>{{ noregistradas_num }}</p>
					<p *ngIf="!hide_prc || force_prc" class="block-prc">{{ noregistradas_prc }}</p>
				</div>
			</div>
      <div class="list-block">
        <span class="total-plus">+</span>
				<p class="tipo-resumen">
					Nulos &nbsp;
          <!-- <span
            tooltip="Es la sumatoria de los votos obtenidos por Partido Político, combinaciones de coalición, Candidatura Común y Candidatura Independiente."
            placement="top" show-delay="200">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </span> -->
				</p>
				<div class="dis-flex flex-row justify-content-between">
					<p>{{ nulos_num }}</p>
					<p *ngIf="!hide_prc || force_prc" class="block-prc">{{ nulos_prc }}</p>
				</div>
			</div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <span class="total-equal">=</span>
      <div class="d-flex total-cont">
        <p>Total de votos
          <span
            tooltip="Se refiere a la suma total de votos que realiza el sistema informático con base en los datos que muestran en cada Acta; podrás consultar la cifra del total de votos mostrado en cada Acta en la base de datos del PREP (numeral 26, fr. XIV del Anexo 13 del Reglamento de Elecciones)."
            placement="top" show-delay="200">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </span>
        </p>
        <p class="pfont total-main">{{ total_num }}</p>
        <p class="pfont">{{ total_prc }}</p>
      </div>
    </div>
  </div>

	<div class="row">
		<div class="col-12" *ngIf="use_observaciones">
			<div class="bgResumen resumen-votacion observaciones p-2">
				<p class="titulo">
					<strong>Observaciones en Acta</strong>
				</p>
				<p (click)="scrollComponent('observaciones')">
          {{ observaciones ? observaciones : '' }}
				</p>
			</div>
		</div>
	</div>
</div>
